import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import '@lucidlink/uicore/integrations/zod/jitless';
import { App } from './App';
const container = document.getElementById('app');
if (!container) {
    throw new Error('Could not find the app container!');
}
createRoot(container).render(_jsx(App, {}));
